import { createAction } from '@reduxjs/toolkit'

import {
  TOrganizationalUnit,
  TOrganizationalUnitGetResponse
} from 'types/GlobalOrganizationalUnit'

// tryGetOrganizationalUnits
export const getAll = createAction('get_organizational_units')
export const getAllSuccess = createAction<TOrganizationalUnitGetResponse>(
  'get_organizational_units_success'
)
export const getAllFailed = createAction('get_organizational_units_failed')

// tryCreateOrganizationalUnit
export const create = createAction('create_organizational_unit')
export const createSuccess = createAction<TOrganizationalUnit>(
  'create_organizational_unit_success'
)
export const createFailed = createAction('create_organizational_unit_failed')

// tryUpdateOrganizationalUnit
export const update = createAction('update_organizational_unit')
export const updateSuccess = createAction<TOrganizationalUnit>(
  'update_organizational_unit_success'
)
export const updateFailed = createAction('update_organizational_unit_failed')

// tryDeleteOrganizationalUnit
export const destroy = createAction('destroy_organizational_unit')
export const destroySuccess = createAction<string>(
  'destroy_organizational_unit_success'
)
export const destroyFailed = createAction('destroy_organizational_unit_failed')
